import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';
import { renderRichText } from '../../../core/utils/render-rich-text.util';

export function adaptTextBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  // Strapi field is `mediaSrc` (media type), fallback to `media`
  const media = (entry['mediaSrc'] ?? entry['media']) as Record<string, unknown> | null;
  const resolvedMedia =
    resolveStrapiMediaUrl(baseUrl, (media?.['url'] as string) ?? null) ?? '';

  return {
    layout: (entry['layout'] as string) ?? 'prose',
    mediaSrc: resolvedMedia,
    mediaAlt: (media?.['alternativeText'] as string) ?? '',
    mediaWidth: (media?.['width'] as number) ?? 0,
    mediaHeight: (media?.['height'] as number) ?? 0,
    body: renderRichText((entry['body'] as string) ?? ''),
  };
}
